import axios from 'axios'
// 全局跳转锁，防止重复跳转登录页
let isRedirecting = false
//HttpOnly Cookie方案 符合web安全规范，满足等保要求
const service = axios.create({
  baseURL: '/', // 接口基础地址 https://www.manalogy.com:8090/
  timeout: 60000, //60内没有收到服务器的响应，从而被客户端强制中断
  withCredentials: true // ✅ 关键：允许跨域携带 Cookie
})

// 请求拦截器：无需手动添加 Token，浏览器会自动携带 Cookie
service.interceptors.request.use(
  config => {
    // 如果是上传文件，设置 Content-Type
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器：处理业务错误
service.interceptors.response.use(
  response => {
    // ✅ 新增判断：如果是二进制流（如图片、文件），返回完整 response 以便获取 headers 和原始 data
    if (response.config.responseType === 'arraybuffer' || response.config.responseType === 'blob') {
      return response; 
    }
    const res = response.data
 
    // 根据后端约定的状态码判断
    if (res.code !== '200') {
      if (res.code === '401' && !isRedirecting) {
        isRedirecting = true
        // Token 失效，跳转登录
        window.location.replace('/?t=' + new Date().getTime());
      }
      // 500 服务器内部错误
      if (res.code === '500') {
        // 可显示服务器错误提示
        console.error('服务器内部错误:', res.result|| '未知错误');
        window.location.replace('/?t=' + new Date().getTime());
      }
      const errorMsg = res.result || '请求失败'
      console.log(res.code+':'+errorMsg)

      return res
    }
    //console.log('返回数据:', res.result);
    return res 
  },
  error => {
    if (error.response && error.response.status === 401 && !isRedirecting) {
      isRedirecting = true
      // 提示用户并跳转登录页
      alert('登录已过期，请重新登录');
      window.location.replace('/?t=' + new Date().getTime());
    }else if (error.response && error.response.status === 500) {
      // 提示用户并跳转登录页
      alert('与服务器连接失败，请重新登录');
 
      // 延迟 100ms 执行，确保 alert 关闭且主线程空闲
      setTimeout(() => {
        window.location.replace('/?t=' + new Date().getTime());
      }, 100);
    }
  
    return Promise.reject(error)
  }
)

export default service
